export function useStatusColor() {
  const getAgendamentoStatusColor = status => {
    if (!status) return 'secondary'
    const s = status.toLowerCase()
    if (s.includes('processado') || s.includes('enviado')) return 'success'
    if (s.includes('agendado')) return 'primary'
    if (s.includes('rascunho')) return 'warning'
    if (s.includes('erro')) return 'error'
    return 'secondary'
  }

  const getLogStatusColor = statusNome => {
    if (!statusNome) return 'secondary'
    const s = statusNome.toLowerCase()
    if (s.includes('enviada') || s.includes('entregue') || s.includes('lida')) return 'success'
    if (s.includes('bounce') || s.includes('não entregue') || s.includes('rejeitada')) return 'error'
    if (s.includes('clicada') || s.includes('verificada')) return 'info'
    return 'secondary'
  }

  return { getAgendamentoStatusColor, getLogStatusColor }
}
